import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IMakeOptional, IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetUserResponseBody } from '../UsersApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseUserQueryValues = {
  userId: string;
};

export const userQueryKeyFactory: IQueryKeyFactory<IUseUserQueryValues> = (
  values?,
) => values && (['users', values.userId] as const);

export const useUserQuery = (
  valuesProp?: IMakeOptional<IUseUserQueryValues, 'userId'>,
  options?: UseQueryOptions<IApiGetUserResponseBody, ApiError>,
): UseQueryResult<IApiGetUserResponseBody, ApiError> => {
  const api = useApi();
  const userId = valuesProp
    ? (valuesProp.userId ?? api.getCurrentUserId())
    : undefined;
  const values: IUseUserQueryValues | undefined =
    valuesProp && userId
      ? {
          ...valuesProp,
          userId,
        }
      : undefined;

  return useQuery({
    queryKey: userQueryKeyFactory(values),
    queryFn: values ? () => api.users.get(values.userId) : undefined,
    enabled: !!values,
    ...options,
  });
};
